"use-strict";
/* global $ */



import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
window.$ = window.jQuery = require('jquery');
import Barba from 'barba.js';
// var imagesLoaded = require('imagesloaded');
// imagesLoaded.makeJQueryPlugin($);
// require("select2-full");
import Swiper from 'swiper/dist/js/swiper.js';
import 'fullpage.js/vendors/easings.min.js';
require('fullpage.js/vendors/scrolloverflow.min.js');
import fullpage from 'fullpage.js'; 
// import ScrollMagic from 'ScrollMagic';
// import 'animation.gsap';
// import 'debug.addIndicators';
// import EasyPZ from 'easypz';
// import noUiSlider from 'nouislider';
// require('malihu-custom-scrollbar-plugin-concat');
// require('jquery-background-video/bgvideo.js');
require('waypoints/lib/noframework.waypoints.min');
import panzoom from 'panzoom';
// import Plyr from 'plyr';
// import hoverintent from 'hoverintent';
import 'parsleyjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import anime from 'animejs';
import objectFitImages from 'object-fit-images';

var Common = {
    lastScrollPos: 0,
    $container: null,
    menuSliders: [],
    popupInstances: [],
    sidebarInstances: [],
    menuStatus: null,
    sectionSlider: null,
    resize: null,
    originIndex: 0,
    newIndex: 0,
    init: function(){
        history.scrollRestoration = "manual";
        Common.detectDevice();
        Common.initBarba();
        Common.detectIE();
        if($('html').hasClass('ie')){
            window.lazySizesConfig = window.lazySizesConfig || {};
            lazySizesConfig.preloadAfterLoad = true;
        }

        $('html').data('font-size', 'font-large');
        document.addEventListener('contextmenu', event => event.preventDefault());
        objectFitImages(null, {watchMQ:true});
        // events
        // $(document).on('click', '.nav-category-button button', Common.openMenuDrawer);
        // $(document).on('mouseleave', '.menu-bar', Common.closeMenu);
        $(document).on('click touch', '#menu-toggle', Common.toggleMenu);
        $(document).on('mouseenter', 'html.desktop .language-toggle', Common.openLang);
        $(document).on('touchend', 'html.mobile .language-toggle', Common.toggleLang);
        $(document).on('mouseleave', 'html.desktop .language-toggle', Common.closeLang);
        $(document).on('mouseenter', 'html.desktop .nav-toggle', Common.openNav);
        $(document).on('touchend', 'html.mobile .nav-toggle', Common.toggleNav);
        $(document).on('mouseleave', 'html.desktop .nav-toggle', Common.closeNav);
        $(window).on('resize orientationchange', Common.video2Cover);
        
        // $(window).on("orientationchange", function(){
        //     window.location.reload(false); 
        // })
    },
    initBarba: function(){
        Barba.Pjax.Dom.containerClass = "transition-container";
        Barba.Pjax.Dom.wrapperId = "transition-wrapper";
        Barba.Pjax.Dom.dataNamespace = "template";
        Barba.Utils.xhrTimeout = 10000;
        Barba.Pjax.cacheEnabled = false;
        Barba.Dispatcher.on('newPageReady', function(current, prev, container) {
            Common.$container = $(container);
            // Common.layout(Common.$container);
            

            // events
            $(document).one('scroll', function(){
                anime({
                    targets: $('#header>.logo')[0],
                    opacity: 0,
                    duration: 300,
                    easing: 'easeOutCubic',
                    complete: function(){
                        $('#header>.logo').hide();
                    }
                });
            });

            $('#header .overlay').on('click', Common.closeMenu);

            Common.arrowAnimation();
            Common.$container.find('.scroll-indicator.down').on("click touch", function() {
                Common.sectionSlider.slideNext();
            });
            Common.$container.find('.scroll-indicator.up').on("click touch", function() {
                Common.sectionSlider.slidePrev();
            });

            Common.$container.find('.open-popup').on('click', function(e){
                var $content = $(e.currentTarget).find('.scrollable-popup-content');
                var popup = new ScrollablePopup();
                popup.open($content);
                if(typeof fullpage_api !== "undefined"){
                    fullpage_api.destroy();
                }
                // fullpage_api.setAutoScrolling(false);
                $(document).scrollTop(0);

                // popup.once('close', function(){
                //     if(!Common.$container.hasClass('detail')){
                //         Common.initFullpage(Common.$container, '', true);
                //     }
                // });
            });

            Common.$container.find('.font-size-selector button').on("click touch", function() {
                var size = $(this).data('size');
                $('html').removeClass('font-small').removeClass('font-medium').removeClass('font-large').addClass(size);
                $('html').data('font-size', size);
                Common.$container.find('.font-size-selector button').removeClass('active');
                Common.$container.find('.font-size-selector button[data-size='+size+']').addClass('active');
            });

            Common.$container.find('.font-size-selector button').each(function() {
                if($('html').hasClass('landing')) return false;
                var size = $('html').data('font-size');
                if($(this).data('size') == size){
                    $(this).addClass('active');
                }else{
                    $(this).removeClass('active');
                }
            });

            Common.$container.find('.ps-image').on("click touch", Common.imagesZoom);

            $(window).on('resize orientationchange', Common.fitMain);

        });
        Barba.Pjax.getTransition = function() {
            return Common.pageTransition;
        };
    },
    pageTransition: Barba.BaseTransition.extend({
        start: function() {
            Promise
                .all([this.newContainerLoading, this.fadeOut()])
                // .then(this.fadeOut.bind(this))
                .then(this.fadeIn.bind(this));
        },
        fadeOut: function() {
            var deferred = Barba.Utils.deferred();

            $("html").removeClass("landing");

            $("#transition-animation").css({
                'pointer-events': 'all',
                opacity: 1
            });

            setTimeout(function(){

                deferred.resolve();
            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 1,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     complete: function(){
            //         deferred.resolve();
                    
            //     }
            // });
            return deferred.promise;
        },
        fadeIn: function() {
            // window.scrollTo(0, 0);
            var _this = this;
            var $container = $(this.newContainer);
            $container.scrollTop(0);
        
            // anime({
            //  targets: this.newContainer,
            //  opacity: 1,
            //  easing: 'easeOutCubic',
            //  duration: 500
            // });
            _this.done();
            
        }
    }),
    pageTransitionLeave: function(){

    },
    pageTransitionEnter: function($container){
        return new Promise(function(resolve){
            // $("#transition-animation .layer-1").show();
            // $("#transition-animation .opening").hide();
            Common.$container.show();
            resolve();
            $("#transition-animation").css({
                opacity: 0
            });

            setTimeout(function(){
                $("#transition-animation").css({
                    'pointer-events': 'none',
                });
                resolve();

            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 0,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     begin: function(){
            //         Common.$container.show();
            //         resolve();
            //     },
            //     complete: function(){
                    
            //     }
            // });
        });
    },
    fitMain: function(){
        var height = $(window).height();
        if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
            Common.$container.find('#main').height(height - 40);
        }else{
            Common.$container.find('#main').height(height);
        }
        
    },
    loadScript: function (src) {
        return new Promise(function (resolve, reject) { 
            if($('script[src="'+ src +'"]').length > 0){
                resolve();
            }else{
                var s;
                s = document.createElement('script');
                s.src = src;
                s.onload = resolve;
                s.onerror = reject;
                document.head.appendChild(s);
            }
        });
    },
    openLang: function(){
        anime({
            targets: Common.$container.find('.language-toggle>.wrapper')[0],
            height: $('html').hasClass('ie') ? 105 : 102,
            easing: 'easeOutCubic',
            duration: 800
        });
        
    },
    closeLang: function(){
        anime({
            targets: Common.$container.find('.language-toggle>.wrapper')[0],
            height: 1,
            easing: 'easeOutCubic',
            duration: 800
        });
    },
    toggleLang: function(){
        var $toggle = Common.$container.find('.language-toggle');
        if($toggle.hasClass('active')){
            Common.closeLang();
        }else{
            Common.openLang();
        }
        $toggle.toggleClass('active');
    },
    openNav: function(){
        var h = Common.$container.find('.nav-toggle>.wrapper>nav>ul').outerHeight();
        // var logoTop = Common.$container.find('.center a.logo').offset().top;
        // var navTop = Common.$container.find('.nav-toggle>.wrapper').offset().top;
        // if(navTop + h + 30 > logoTop){
        //     anime({
        //         targets: Common.$container.find('.menu-bar .center')[0],
        //         translateY: navTop + h + 30 - logoTop,
        //         easing: 'easeOutCubic',
        //         duration: 800
        //     });
        // }
        // anime.set({
        //     targets: Common.$container.find('.nav-toggle>.wrapper>nav')[0],
        //     height: h,
        //     easing: 'easeOutCubic',
        //     duration: 800
        // });
        Common.$container.find('.nav-toggle>.wrapper>nav').height(h);
    },
    closeNav: function(){
        Common.$container.find('.nav-toggle>.wrapper>nav').height(5);

        anime({
            targets: Common.$container.find('.menu-bar .center')[0],
            translateY: 0,
            easing: 'easeOutCubic',
            duration: 800
        });
    },
    toggleNav: function(){
        var $toggle = Common.$container.find('.nav-toggle');
        if($toggle.hasClass('active')){
            Common.closeNav();
        }else{
            Common.openNav();
        }
        $toggle.toggleClass('active');
    },
    arrowAnimation: function(){
        // $(document).find('.scroll-indicator.down').each(function(){
        //     var $this = $(this);
        //     anime({
        //         targets: $this[0],

        //     });
        // });
    },
    // layout: function($container){
    //     if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
    //         $container.find('.mobile-move').each(function(){
    //             var $this = $(this);
    //             var target = $this.closest('.section').data('section');
    //             $this.appendTo($container.find('.mobile-section[data-target='+target+']'));
    //         });
    //     }else if(!window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
            
    //     }
    // },
    stopFullpage: function(){
        if(typeof fullpage_api !== "undefined"){
            fullpage_api.destroy();
        }
    },
    initFullpage: function($container, sectionClass, noDestroy){
        return new Promise(function(resolve){
            if(typeof fullpage_api !== "undefined" && noDestroy){
                fullpage_api.destroy();
            }else if(typeof fullpage_api !== "undefined"){
                fullpage_api.destroy('all');
            }
            if(!sectionClass){
                if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                    sectionClass = '.mobile-section';
                }else if(!window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                    sectionClass = '.section';
                }
            }
            var responsiveWidth = $container.hasClass('contact') ? 1023 : 0;
            // var scrollOverflowOptions = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches ? {
            //         scrollbars: false,
            //         mouseWheel: true
            //     } : {};

            new fullpage($container.find('#main')[0], {
                licenseKey: '49515120-99A84FF4-AF76AC2A-2B672DA2',
                css3: true,
                scrollBar: true,
                easing: 'easeOutCubic',
                hybrid:true,
                // responsiveWidth: 1024,
                // fitToSection: false,
                slideSelector: '.fp-slide',
                sectionSelector: sectionClass,
                touchSensitivity: 20,
                // bigSectionsDestination: 'bottom',
                afterRender: function(){
                    resolve();
                },
                afterLoad: function(origin, destination, direction){
                    if($(destination.item).hasClass('fp-stop')){
                        fullpage_api.setAllowScrolling(false);
                    }else if($(destination.item).hasClass('fp-stop-down')){
                        fullpage_api.setAllowScrolling(false, 'down');
                    }else{
                        fullpage_api.setAllowScrolling(true);
                    }
                },
                onLeave: function(origin, destination, direction){
                    if($(destination.item).hasClass('fp-stop')){
                        fullpage_api.setAllowScrolling(false);
                    }else if($(destination.item).hasClass('fp-stop-down')){
                        fullpage_api.setAllowScrolling(false, 'down');
                    }else{
                        fullpage_api.setAllowScrolling(true);
                    }
                },
                responsiveWidth: responsiveWidth,
                // afterLoad: function(origin, destination, direction){
                //     if ($(destination.item).hasClass('extend') && window.matchMedia('(min-width: 1024px)').matches && direction == 'down'){
                //         fullpage_api.setAutoScrolling(false);
                //         // fullpage_api.setFitToSection(false);

                //         $(document).on('scroll.fp', function(){
                //             var offset = $(destination.item).offset();
                //             var $w = $(window);

                //             if (offset.top - $w.scrollTop() > 0){
                //                 var data = fullpage_api.getFullpageData();
                //                 if(!data.autoScrolling) fullpage_api.setAutoScrolling(true);
                //                 // if(!data.fitToSection) fullpage_api.setFitToSection(true);
                //                 $(document).off('scroll.fp');
                //             }else if(offset.top + $(destination.item).height() < $w.scrollTop() + $w.height()){
                //                 var data = fullpage_api.getFullpageData();
                                
                //                 fullpage_api.moveSectionDown();
                //                 if(!data.autoScrolling) fullpage_api.setAutoScrolling(true);
                //                 $(document).off('scroll.fp');
                //             }
                //         });
                //     }else if($(destination.item).hasClass('extend') && window.matchMedia('(min-width: 1024px)').matches && direction == 'up'){
                        
                //         var pos = $(destination.item).offset().top + $(destination.item).height() - $(window).height();
                //         fullpage_api.setAutoScrolling(false);
                //         $(window).scrollTop(pos);

                //         $(document).on('scroll.fp', function(){
                //             var offset = $(destination.item).offset();
                //             var $w = $(window);

                //             if(offset.top - $w.scrollTop() > 0){
                //                 var data = fullpage_api.getFullpageData();
                //                 if(!data.autoScrolling) fullpage_api.setAutoScrolling(true);
                //                 $(document).off('scroll.fp');
                //             }else if(offset.top + $(destination.item).height() < $w.scrollTop() + $w.height()){
                //                 var data = fullpage_api.getFullpageData();
                                
                //                 fullpage_api.moveSectionDown();
                //                 if(!data.autoScrolling) fullpage_api.setAutoScrolling(true);
                //                 $(document).off('scroll.fp');
                //             }
                //         });
                //     }
                // },
                // onLeave: function(origin, destination, direction){
                //     // if(destination.index !== 0 && window.matchMedia('(min-width: 1024px)').matches){
                //     //     anime.remove($container.$container.find('.section.content .bkgimg').toArray());
                //     //     var $slide = $(destination.item);
                //     //     if($slide.hasClass('content')){
                //     //         anime.timeline().add({
                //     //             targets: $slide.find('.bkgimg')[0],
                //     //             scale: [1, 1.15],
                //     //             duration: 10000,
                //     //             easing: 'linear'
                //     //         }).add({
                //     //             targets: $slide.find('.wrapper')[0],
                //     //             opacity: [0, 1],
                //     //             translateY: [40, 0],
                //     //             duration: 1000,
                //     //             easing: 'easeOutCubic',
                //     //             complete: function(){
                //     //                 $container.$container.find('.section .wrapper').not($slide.find('.wrapper')).css({opacity: 0});
                //     //             }
                //     //         }, 700);
                //     //     }
                //     // }
                // }
            });
        });
    },
    responsiveFullpage: function(){
        if(typeof fullpage_api !== "undefined"){
            if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches && fullpage_api.getFullpageData().sectionSelector === '.section'){
                Common.initFullpage(Common.$container, '.mobile-section');
            }else if(!window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches && fullpage_api.getFullpageData().sectionSelector === '.mobile-section'){
                Common.initFullpage(Common.$container, '.section');
            }
        }
    },
    // openMenuDrawer: function(e){
    //     var $target = $(e.currentTarget).closest('.nav-category').find('.nav-category-children');
    //     var height = $target.find('ul').outerHeight();
    //     anime.timeline().add({
    //         targets: $('.nav-category .nav-category-children').not($target).toArray(),
    //         height: 0,
    //         duration: 320,
    //         easing: 'easeOutCubic'
    //     }).add({
    //         targets: $target[0],
    //         height: height,
    //         duration: 300,
    //         easing: 'easeOutCubic'
    //     });
    // },
    // closeMenuDrawer: function(e){
    //     $('.nav-category .nav-category-children').height(0);
    // },
    toggleMenu: function(){
        if(!$('#header').hasClass('menu-opened')){
            Common.openMenu();
        }else{
            Common.closeMenu();
        }
    },
    openMenu: function(){
        // clearTimeout(Common.menuStatus);
        // if(!$('.menu-bar').hasClass('animating')){
            // $('.menu-bar .indicator').removeClass('active');
            if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                // anime.set($('.menu-bar')[0], {
                //     translateX: -250,
                // });
                $('#header').addClass('menu-opened');
                var height = $(window).height();
                $('.menu-bar').height(height);
                Common.openNav();
            }else{
                anime.set($('.menu-bar')[0], {
                    translateX: -250,
                });
                anime({
                    targets: $('.menu-bar')[0],
                    translateX: 0,
                    duration: 600,
                    easing: 'easeOutQuart',
                    // before: function(){
                    //     $('.menu-bar').addClass('animating');
                    // },
                    before: function(){
                        // $('.menu-bar').removeClass('animating');
                        $('#header').addClass('menu-opened');
                    }
                });
            }
            

            
            // anime({
            //     targets: $('footer .disclaimer')[0],
            //     paddingLeft: 220,
            //     duration: 600,
            //     easing: 'easeOutQuart',
            // });
            // anime({
            //     targets: Common.$container.find('#main')[0],
            //     marginLeft: 250,
            //     duration: 600,
            //     easing: 'easeOutQuart'
            // });
            // if(Common.$container.data('template') === 'home'){
            //     anime({
            //         targets: Common.$container.find('.center-text')[0],
            //         width: $(window).width() - 250,
            //         duration: 600,
            //         easing: 'easeOutQuart'
            //     });
            // }
        // }
    },
    closeMenu: function(e){
        // return new Promise(function(resolve){
            if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                $('#header').removeClass('menu-opened');
                $('.menu-bar').height(40);
            }else{
                anime({
                    targets: $('.menu-bar')[0],
                    translateX: -267,
                    duration: 600,
                    easing: 'easeOutQuart',
                    // before: function(){
                    //     $('.menu-bar').addClass('animating');
                    // },
                    // complete: function(){
                    //     $('.menu-bar').removeClass('animating');
                    // }
                    before: function(){
                        // $('.menu-bar').removeClass('animating');
                        $('#header').removeClass('menu-opened');
                    }
                });
            }
            
            // if(e === true){
            //     $('.menu-bar').css({
            //         transform: 'translateX(-250px)'
            //     });
            //     $('footer .disclaimer').css({
            //         paddingLeft: 0
            //     });
            //     Common.$container.find('#main').css({
            //         marginLeft: 30
            //     });
            //     $('.menu-bar .indicator').addClass('active');
            // }else if(!$('.menu-bar').hasClass('animating') && e.target.tagName !== 'A' && Common.$container.data('template') !== 'home'){
            //     Common.startCloseMenuAnimation(resolve);
            // }else if($('.menu-bar').hasClass('animating') && e.target.tagName !== 'A' && Common.$container.data('template') !== 'home'){
            //     Common.menuStatus = setTimeout(function(){
            //         Common.startCloseMenuAnimation(resolve);
            //     }, 1500);
            // }
        // });
    },
    // startCloseMenuAnimation: function(resolve){
    //     anime({
    //         targets: $('.menu-bar')[0],
    //         translateX: -220,
    //         duration: 600,
    //         easing: 'easeOutQuart',
    //         before: function(){
    //             $('.menu-bar').addClass('animating');
    //         },
    //         complete: function(){
    //             $('.menu-bar .indicator').addClass('active');
    //             $('.menu-bar').removeClass('animating');
    //             resolve();
    //         }
    //     });
    //     anime({
    //         targets: $('footer .disclaimer')[0],
    //         paddingLeft: 0,
    //         duration: 600,
    //         easing: 'easeOutQuart',
    //     });
    //     anime({
    //         targets: Common.$container.find('#main')[0],
    //         marginLeft: 30,
    //         duration: 600,
    //         easing: 'easeOutQuart'
    //     });
    //     if(Common.$container.data('template') === 'home'){
    //         anime({
    //             targets: Common.$container.find('.center-text')[0],
    //             width: $(window).width() - 30,
    //             duration: 600,
    //             easing: 'easeOutQuart'
    //         });
    //     }
    // },
    detectDevice: function(){
        // $(window).on('mouseover', function onFirstHover() {
        //     $('html').addClass('desktop').removeClass('mobile');
        //     $(window).off('mouseover', onFirstHover, false);
        // });
        if(!('ontouchstart' in window)){
            $('html').addClass('desktop').removeClass('mobile');
        }
    },
    detectIE: function() {
        var isIE = false;
        var ua = window.navigator.userAgent;

        if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) isIE = true;

        if(isIE) $('html').addClass('ie');

    },
    isMobile: function(){
        // return window.matchMedia('(max-width: 768px) and (orientation: portrait)').matches || window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches;
        if(!('ontouchstart' in window)){
            return false;
        }
        return true;
    },
    menuShrink: function(){
        // if(window.matchMedia('(max-width: 767px)').matches){
        //  if($(window).scrollTop() > 50 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 50 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
        //  if($(window).scrollTop() > 60 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 60 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else{
        //  if($(window).scrollTop() > 200 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //      var expand = new TimelineMax();
        //      expand.to('#header-body-center .logo', 0.3, {'width': 179, height:32, ease:Power3.easeOut}, 0);
        //  }else if($(window).scrollTop() <= 200 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //      var shrink = new TimelineMax();
        //      shrink.to('#header-body-center .logo', 0.3, {'width': 256, height:102, ease:Power3.easeOut}, 0);
        //  }
        // }
        
    },
    
    beautifyScrollbar: function(){
        // var $dropdown = $('.select2-dropdown .select2-results__options');
        // var $container = $dropdown.parents('.select2-dropdown');
        // TweenLite.set($container, {autoAlpha: 0});
        // if($dropdown.length > 1){
        //  $dropdown.last().mCustomScrollbar('destroy');
        // }else $dropdown.mCustomScrollbar('destroy');
        // setTimeout(function() {
        //  $dropdown.mCustomScrollbar({
        //      advanced:{
        //          updateOnContentResize: true
        //      },
        //      theme:"dark-2",
        //      scrollInertia: 200
        //  });
            
        //  TweenLite.to($container, 0.3, {autoAlpha: 1, ease: Power4.easeout});
        // }, 0);
    },
    throttle: function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},
    debounce: function(a,b,c){var d,e;return function(){function h(){d=null,c||(e=a.apply(f,g))}var f=this,g=arguments;return clearTimeout(d),d=setTimeout(h,b),c&&!d&&(e=a.apply(f,g)),e}},

    imagesZoom: function(e){
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $wrapper = $this.closest('.ps-wrapper').length ? $this.closest('.ps-wrapper') : $this.closest('.section');
        var $image = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image');
        var index = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image').index($this);
        var items = [];
        $image.each(function(){
            const src = $(this).data("ps-src") || $(this).attr("src");
            const w = $(this).data("ps-w") || this.naturalWidth;
            const h = $(this).data("ps-h") || this.naturalHeight;
            var caption = $(this).data("ps-caption") || '';
            caption = caption.split(' - ');
            if(caption.length === 2){
                caption = caption[0] + '<br>' + caption[1];
            }else{
                caption = caption[0];
            }
            items.push({
                src: src,
                w: w,
                h: h,
                msrc: src,
                title: caption
            });
        });
        var $pswp = $('.pswp')[0];
        var options = {
                index: index,
                bgOpacity: 0.95,
                // showHideOpacity: true,
                // showAnimationDuration: 2000,
                history: false,
                // fullscreenEl: true,
                shareEl: false,
                // counterEl: false,
                // closeOnScroll: false,
                scaleMode: 'fit',
                // getThumbBoundsFn: function(i) {
                //     var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                //     var rect = $image[i].getBoundingClientRect();
                //     return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                // }
        }
        var ps = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        ps.init();
    },
    mobileShare: function(e){
        e.preventDefault();
        var url = document.location.href;
        if (navigator.share) {
          navigator.share({
              url: url
          });
        }
    },
    video2Cover: function(){
        if(Common.$container){
            Common._video2Cover();
            clearTimeout(Common.resize);
            Common.resize = setTimeout(function(){
                Common._video2Cover();
            }, 500);
            
        }
    },
    _video2Cover: function(){
        var $videos = Common.$container.find('.cover-video');
        $videos.each(function(){
            var $this = $(this);
            var parentWidth = $this.parent().outerWidth();
            var parentHeight = $this.parent().outerHeight();
            var aspectRatio = $this.data('ratio') ? $this.data('ratio') : 1.2;
            var newHeight, newWidth, halfWidth, halfHeight;
            if(parentWidth / parentHeight > aspectRatio){
                if(newWidth > parentWidth){
                    newWidth = parentHeight*aspectRatio;
                    newHeight = newWidth/aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height": newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "top":"auto",
                        "transform": "translate(-"+halfWidth+"px, 0)"
                    });
                }else{
                    newHeight = parentWidth/aspectRatio;
                    newWidth = newHeight*aspectRatio;
                    halfHeight = newHeight/2;
                    $this.css({
                        "height":newHeight,
                        "width": newWidth,
                        "left": 0,
                        "top":"50%",
                        "transform": "translate(0, -"+halfHeight+"px)"
                    });
                }
            }else{
                newHeight = parentHeight;
                newWidth = newHeight*aspectRatio;
                halfWidth = newWidth/2;
                $this.css({
                    "height":newHeight,
                    "width":newWidth,
                    "left":"50%",
                    "top": 0,
                    "transform": "translateX(-"+halfWidth+"px)"
                });
            }
                
        });
    }
    
}

var Home = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'home',
        onEnter: function() {
            Home.$container = $(this.container);

            
            if($('html').hasClass('landing')){
                // var startDate = "01-02-2020";
                // startDate = startDate.split("-");
                // startDate = startDate[1] + "/" + startDate[0] + "/" + startDate[2];
                // startDate = new Date(startDate).getTime();

                // var endDate = "11-02-2020";
                // endDate = endDate.split("-");
                // endDate = endDate[1] + "/" + endDate[0] + "/" + endDate[2];
                // endDate = new Date(endDate).getTime();

                // var currentDate = new Date().getTime();

                // // var valid = currentDate > startDate && currentDate < endDate;
                // var valid = true;
                // if(valid){
                //     var $content = Home.$container.find('.scrollable-popup-content.popup');
                //     var popup = new ScrollablePopup();
                //     popup.open($content, 'temp');
                //     if(typeof fullpage_api !== "undefined"){
                //         fullpage_api.destroy();
                //     }

                //     $(document).scrollTop(0);

                //     popup.once('close', function(){
                //         if(!Common.$container.hasClass('detail')){
                //             Common.initFullpage(Common.$container, '', true);
                //         }
                //     });
                // }
                
                // $('.menu-bar').css({
                //     transform: 'translateX(0)'
                // }).find('.indicator').removeClass('active');
                // $('footer .disclaimer').css({
                //     "padding-left": 220
                // })
                // Home.$container.find('#main').css({
                //     "margin-left": 250,
                // });
                // Home.$container.find('.center-text').css({
                //     width: $(window).width() - 250
                // });
                
            }

            // Home.initRunning();

            

            // events
            // Home.$container.find('video').on("loadstart", function() {
            //     $(this).bgVideo({
            //         fullScreen: true
            //     });
            //     setTimeout(function(){
            //         $(window).trigger('resize');
            //     }, 200);
            // });
            $(window).on('resize.home orientationchange.home', function(){
                var lang = Home.$container.data('language');
                var portraitVideoSrc = '/site/templates/videos/Home_Portrait.mp4';
                var landscapeVideoSrc = '/site/templates/videos/Home_Landscape.mp4';
                var src = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                var ratio = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? 0.7883211679 : 1.7454545455;
                Home.$container.find('video source').attr('src', src);
                Home.$container.find('video').data('ratio', ratio);
                Home.$container.find('video')[0].load();
                Home.$container.find('video')[0].play();
            }).trigger('resize');

            // $(window).on("resize orientationchange", function(){
            //     Home.resize();
            // })
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Home.$container).then(function(){
                $(window).trigger('resize');
                Home.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = {
                        speed: 1000,
                        slidesPerView:'auto',
                        resistanceRatio: 0,
                        mousewheel: {
                            // invert: true,
                        },
                        direction: 'vertical',
                        scrollbar: scrollbar,
                        on: {
                            init: function(){
                                Home.$container.find('.section').addClass("from-above");
                                Home.$container.find('video')[0].play();
                            }
                        }
                    };

                    Common.sectionSlider = new Swiper (this, option);
                });

                $(window).trigger('resize');
            
            });
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    }),
    initRunning: function(){
        var slides = Home.$container.find(".slide");
        var amount = slides.length;

        Home.$container.find(".slide h3").each(function(){
            var charCount = $(this).text().length;
            var $lines = $(this).find('div');
            $lines.each(function(){
                $(this).html($(this).text().replace(/(\S|\s)/g, function(c){
                    return "<span class='letter'>"+c+"</span>";
                }));
            });
        });

        Home.$container.find(".center-text").css({
            display: 'flex'
        });

        anime({
            targets: Home.$container.find("h2")[0],
            opacity: [0, 1],
            translateY: [50, 0],
            duration: 500,
            easing: "easeOutCubic"
        });

        Home.$container.find(".slide").css({visibility: 'visible'});

        // anime.set(Home.$container.find(".slide .letter").toArray(), {
        //     translateY: -10,
        //     opacity: 0
        // });

        Home.runningPromotionAnimation(slides.eq(0));

        // var i = 1;
        // setInterval(function(){
        //     var last = i % amount;
        //     var next = (i + 1) % amount;
        //     var lastEle = slides.eq(last);
        //     var nextEle = slides.eq(next);

        //     Home.runningPromotionAnimation(lastEle, nextEle);
        //     i++;
        // }, 6000);
    },
    runningPromotionAnimation: function(nextEle){
        var speed = 600 / nextEle.find('.letter').length;
        anime.timeline().add({
            targets: nextEle[0].querySelectorAll('.letter'),
            keyframes: [
                {translateY: -10, opacity: 0, easing: 'easeOutBack'},
                {translateY: 0, opacity: 1, easing: 'easeOutBack'},
            ],
            translateZ: 0,
            duration: 800,
            delay: function(el, j) {
                return speed * j;
            }
        }, 0);
    },
    resize: function(){
        // Home.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        // Home.headerHeight = $('#header').outerHeight(true);
        
        // Home.$container.find('.new-york .parallax-wrapper').css({
        //     top: -Home.windowHeight
        // });
        // if($(window).width() !== Home.cachedWidth || window.matchMedia('(min-width: 1025px)').matches){
        //     Home.cachedWidth = $(window).width();
        //     Home.setKVHeight();
        //     // Home.videoFit();
        // }

        // anime({
        //     targets: Home.$container.find('.center-text')[0],
        //     width: $(window).width() - 250,
        //     duration: 600,
        //     easing: 'easeOutQuart'
        // });
    }
}

var Vision = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'vision',
        onEnter: function() {
            Vision.$container = $(this.container);

            

            // events
            $(window).on('resize.vision orientationchange.vision', function(){
                var portraitVideoSrc = '/site/templates/videos/Interview_Portrait.mp4';
                var landscapeVideoSrc = '/site/templates/videos/Interview_Landscape.mp4';
                var src = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                var ratio = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? 0.72 : 1.7010309278;
                Vision.$container.find('.video-bkg video source').attr('src', src);
                Vision.$container.find('.video-bkg video').data('ratio', ratio);
                Vision.$container.find('.video-bkg video')[0].load();
                Vision.$container.find('.video-bkg video')[0].play();
            });

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Vision.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                // var section = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches ? '.mobile-section' : '.section';
                
                Common.loadScript("https://amp.azure.net/libs/amp/latest/azuremediaplayer.min.js").then(function(){
                    Vision.videoPlayer = amp(Vision.$container.find('.azuremediaplayer')[0], {
                        controls: true
                    });

                    Vision.videoPlayer.play();
                    Vision.videoPlayer.pause();
                    Vision.$container.find('.open-video-popup').on('click', function(e){
                        var $content = $(e.currentTarget).find('.scrollable-popup-content');
                        var popup = new ScrollablePopup();
                        var startTime = new Date();
                        var videoTitle = $(this).data('name');
                        popup.open($content, 'video');

                        dataLayer.push({
                            'event': 'video_play',
                            'gtm.videoTitle': videoTitle
                        });

                        if(popup.$popup.find('.azuremediaplayer').length){
                            var video = popup.$popup.find('.azuremediaplayer video')[0];
                            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                                && video.readyState > 2;

                            if (!isPlaying) {
                                Vision.videoPlayer.play();
                            }

                            

                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }
                            

                            

                            Vision.videoPlayer.addEventListener(amp.eventName.ended, function(){
                                popup.close();
                            });

                            popup.$popup.find('video').css({
                                visibility: 'visible',
                            });

                            setTimeout(function(){
                                popup.$popup.find('video').css({
                                    opacity: 1
                                });
                                // Vision.videoPlayer.play();
                            }, 100);

                            video.addEventListener('ended', function(){
                                popup.close();
                            }, false);

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'event': 'video_play_time',
                                    'playTime': playTime,
                                    'gtm.videoTitle': videoTitle
                                });
                                Vision.videoPlayer.pause();
                                Vision.videoPlayer.currentTime(0);
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }else{
                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }

                            var video = popup.$popup.find('video')[0];
                            video.currentTime = 0;
                            video.play();

                            video.addEventListener('ended', function(){
                                popup.close();
                            }, false);

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'playTime': playTime,
                                });
                                video.pause();
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }
                    });
                });


                

                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            Vision.$container.find('video').off("loadstart");
            Vision.$container.find('.audio').off("click");
            Vision.$container.find('button.play').off("click");
            Vision.$container.find('.section.video video').off('click');
            $(window).off('resize.vision orientationchange.vision');
        },
        onLeaveCompleted: function() {
        
        }
    })
}

var Collaboration = {
    $container: null,
    carousels: [],
    players: [],
    section: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'collaboration',
        onEnter: function() {
            Collaboration.$container = $(this.container);

            

            // Collaboration.$container.find(".fade").css({
            //     opacity: 0
            // });

            // events
            // Collaboration.$container.find('video.fullScreen').on("loadstart", function() {
            //     $(this).bgVideo({
            //         fullScreen: true
            //     });
            // });

            Collaboration.$container.find('.partnership .audio').on("click", function() {
                $(this).toggleClass('off');
                if($(this).hasClass('off')){
                    $(this).siblings('div').find('video').prop('muted', true);
                }else{
                    $(this).siblings('div').find('video').prop('muted', false);
                }
            });

            Collaboration.$container.find('button.play').on("click", function() {
                $(this).siblings('video')[0].play();
                $(this).hide();
            });

            Collaboration.$container.find('.bkgpic > .swiper-container').each(function(){
                new Swiper (this, {
                    slidesPerView: 1,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    autoplay: {
                        delay: 10000,
                        disableOnInteraction: false
                    },
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next'),
                        prevEl: $(this).find('.swiper-button-prev'),
                    }
                });
            });
            

            // Collaboration.players = new Plyr(Collaboration.$container.find('video.manual')[0], {
            //     hideControls: true,
            //     showPosterOnEnd: true,
            //     // fullscreen: {
            //     //     enabled: false
            //     // },
            //     controls: ['progress']
            // });

            // Collaboration.players.on('click touch', function(){
            //     if((!Collaboration.players.playing && !Common.isMobile()) || (Collaboration.players.playing && Common.isMobile())){
            //         Collaboration.players.stop();
            //     }else{
            //         Collaboration.players.play();
            //     }
                
            // });
            

            // events
            

            // Collaboration.$container.find('.section.video video').on('click', function(){
            //     $(this)[0].pause();
            //     Collaboration.$container.find('button.play').show();
            // });
        },
        onEnterCompleted: function() {

            Common.pageTransitionEnter(Collaboration.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                Common.loadScript("https://amp.azure.net/libs/amp/latest/azuremediaplayer.min.js").then(function(){
                    Collaboration.videoPlayer = amp(Collaboration.$container.find('.azuremediaplayer')[0], {
                        controls: true
                    });

                    Collaboration.videoPlayer.play();
                    Collaboration.videoPlayer.pause();
                    // Collaboration.videoPlayer.currentTime(0);
                    Collaboration.$container.find('.open-video-popup').on('click', function(e){
                        var $content = $(e.currentTarget).find('.scrollable-popup-content');
                        var popup = new ScrollablePopup();
                        var startTime = new Date();
                        var videoTitle = $(this).data('name');
                        popup.open($content, 'video');

                        dataLayer.push({
                            'event': 'video_play',
                            'gtm.videoTitle': videoTitle
                        });

                        if(popup.$popup.find('.azuremediaplayer').length){
                            var video = popup.$popup.find('.azuremediaplayer video')[0];
                            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                                && video.readyState > 2;

                            if (!isPlaying) {
                                Collaboration.videoPlayer.play();
                            }

                            

                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }
                            

                            

                            Collaboration.videoPlayer.addEventListener(amp.eventName.ended, function(){
                                popup.close();
                            });

                            popup.$popup.find('video').css({
                                visibility: 'visible',
                            });

                            setTimeout(function(){
                                popup.$popup.find('video').css({
                                    opacity: 1
                                });
                                $(window).trigger('resize');
                                // Collaboration.videoPlayer.play();
                            }, 100);

                            video.addEventListener('ended', function(){
                                popup.close();
                            }, false);

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'event': 'video_play_time',
                                    'playTime': playTime,
                                    'gtm.videoTitle': videoTitle
                                });
                                Collaboration.videoPlayer.pause();
                                Collaboration.videoPlayer.currentTime(0);
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }else{
                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }

                            var video = popup.$popup.find('video')[0];
                            video.currentTime = 0;
                            video.play();

                            video.addEventListener('ended', function(){
                                popup.close();
                            }, false);

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'playTime': playTime,
                                });
                                video.pause();
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }
                    });
                });

                $(window).on('resize.collaboration orientationchange.collaboration', function(){
                    var portraitVideoSrc = '/site/templates/videos/Res_Portrait.mp4';
                    var landscapeVideoSrc = '/site/templates/videos/Res_Landscape.mp4';
                    var src = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                    var ratio = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? 0.72 : 1.7010309278;
                    Collaboration.$container.find('.video-bkg video source').attr('src', src);
                    Collaboration.$container.find('.video-bkg video').data('ratio', ratio);
                    Collaboration.$container.find('.video-bkg video')[0].load();
                    Collaboration.$container.find('.video-bkg video')[0].play();
                });

                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            Collaboration.$container.find('video').off("loadstart");
            Collaboration.$container.find('.audio').off("click");
            Collaboration.$container.find('button.play').off("click");
            Collaboration.$container.find('.section.video video').off('click');
            $(window).off('resize.collaboration orientationchange.collaboration');
            $(window).off('orientationchange.collaboration2');
            Collaboration.players.forEach(function(player) {
                player.pause();
            });
            Collaboration.$container.find('.audio').siblings('div').find('video').prop('muted', true);
        },
        onLeaveCompleted: function() {
        
        }
    })
}

function preventDefault(event){
    if(event.preventDefault){
        event.preventDefault();
    }
    else{
        event.returnValue = false;
    }
}

var Creation = {
    $container: null,
    carousels: [],
    videos: [],
    videoPlayers: [],
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'creation',
        videoPlayer: null,
        onEnter: function() {
            Creation.$container = $(this.container);

            Creation.$container.find(".fade").css({
                opacity: 0
            });

            // events
            Creation.$container.find('img.ps-image').on('click', Common.imagesZoom)
            
            // Creation.$container.find('video').on("loadstart", function() {
            //     $(this).bgVideo({
            //         fullScreen: true
            //     });
            // });

            // Creation.$container.find('.audio').on("click", function() {
            //     $(this).toggleClass('off');
            //     if($(this).hasClass('off')){
            //         $(this).siblings('div').find('video').prop('muted', true);
            //     }else{
            //         $(this).siblings('div').find('video').prop('muted', false);
            //     }
            // });
            document.addEventListener('lazybeforeunveil', function(e){
                // e.preventDefault();
            });
            
        },
        onEnterCompleted: function() {

            Common.pageTransitionEnter(Creation.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                Common.loadScript("https://amp.azure.net/libs/amp/latest/azuremediaplayer.min.js").then(function(){

                    Creation.videoPlayer = [];
                    var $videos = Creation.$container.find('.azuremediaplayer');
                    for (var i = 0; i < $videos.length; i++) {
                        Creation.videoPlayer[i] = null;
                        Creation.videoPlayer[i] = amp(Creation.$container.find('.azuremediaplayer')[i], {
                            controls: true
                        });



                    }
                    

                    Creation.$container.find('.open-video-popup').on('click', function(e){
                        var $content = $(e.currentTarget).find('.scrollable-popup-content');
                        var popup = new ScrollablePopup();
                        var startTime = new Date();
                        var videoTitle = $(this).data('name');
                        var index = Creation.$container.find('.open-video-popup').index(this);console.log(index);
                        popup.open($content, 'video');

                        dataLayer.push({
                            'event': 'video_play',
                            'gtm.videoTitle': videoTitle
                        });

                        if(popup.$popup.find('.azuremediaplayer').length){
                            var video = popup.$popup.find('.azuremediaplayer video')[0];

                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }
                            

                            Creation.videoPlayer[index].play();

                            popup.$popup.find('video').css({
                                visibility: 'visible',
                            });

                            setTimeout(function(){
                                popup.$popup.find('video').css({
                                    opacity: 1
                                });
                            }, 100);


                            Creation.videoPlayer[index].addEventListener(amp.eventName.ended, function(){
                                popup.close();
                            });

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'event': 'video_play_time',
                                    'playTime': playTime,
                                    'gtm.videoTitle': videoTitle
                                });
                                Creation.videoPlayer[index].pause();
                                Creation.videoPlayer[index].currentTime(0);
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }else{
                            if(popup.$popup.find('.content').width() / popup.$popup.find('.content').height() > 1.777777777777777){
                                popup.$popup.find('.content').css({
                                    width: Math.floor(popup.$popup.find('.content').height() * 1.777777777777777),
                                    margin: '30px auto'
                                });
                            }else{
                                const height = Math.ceil(popup.$popup.find('.content').width() / 1.777777777777777);
                                popup.$popup.find('.content').css({
                                    height: height,
                                    margin: ($(window).height() - height)/2 + 'px 60px'
                                });
                            }

                            var video = popup.$popup.find('video')[0];
                            video.currentTime = 0;
                            video.play();

                            video.addEventListener('ended', function(){
                                popup.close();
                            }, false);

                            popup.once('close', function(){
                                var endTime = new Date();
                                var playTime = (endTime.getTime() - startTime.getTime()) / 1000;
                                dataLayer.push({
                                    'playTime': playTime,
                                });
                                video.pause();
                                Common.sectionSlider.mousewheel.handleMouseEnter();
                            });
                        }
                        
                    });

                    
                });

                $(window).on('resize.creation orientationchange.creation', function(){
                    var portraitVideoSrc = '/site/templates/videos/Docu_Portrait.mp4';
                    var landscapeVideoSrc = '/site/templates/videos/Docu_Landscape.mp4';
                    var src = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? portraitVideoSrc : landscapeVideoSrc;
                    var ratio = window.matchMedia('(max-width:1024px) and (orientation: portrait)').matches ? 0.72 : 1.7010309278;
                    Creation.$container.find('.video-bkg video source').attr('src', src);
                    Creation.$container.find('.video-bkg video').data('ratio', ratio);
                    Creation.$container.find('.video-bkg video')[0].load();
                    Creation.$container.find('.video-bkg video')[0].play();
                });

                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            Creation.$container.find('video').off("loadstart");
            Creation.$container.find('.audio').off("click");
            Creation.$container.find('button.play').off("click");
            Creation.$container.find('.section.video video').off('click');
            $(window).off('resize.creation orientationchange.creation');
            // Creation.videoPlayer.pause();
        },
        onLeaveCompleted: function() {
        
        }
    })
}

var ShowFlat = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'show-flat',
        onEnter: function() {
            ShowFlat.$container = $(this.container);

            ShowFlat.$container.find(".fade").css({
                opacity: 0
            });

            // events
            // ShowFlat.$container.find('video').on("loadstart", function() {
            //     $(this).bgVideo({
            //         fullScreen: true
            //     });
            // });

            ShowFlat.$container.find('.audio').on("click", function() {
                $(this).toggleClass('off');
                if($(this).hasClass('off')){
                    $(this).siblings('div').find('video').prop('muted', true);
                }else{
                    $(this).siblings('div').find('video').prop('muted', false);
                }
            });
        },
        onEnterCompleted: function() {
            Common.initFullpage(ShowFlat.$container);

            Common.pageTransitionEnter(ShowFlat.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                ShowFlat.$container.find('.slider>.swiper-container').each(function(){
                    var option = {
                        slidesPerView: 1,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false
                        },
                        navigation: {
                            nextEl: $(this).siblings('.slider>.swiper-button-next'),
                            prevEl: $(this).siblings('.slider>.swiper-button-prev'),
                        }
                    };
                    // if($('html').hasClass('ie')){
                    //     option.speed = 0;
                    //     option.effect= 'fade';
                    //     option.fadeEffect = {
                    //         crossFade: true
                    //     };
                    // }
                    var slider = new Swiper (this, option);
                });

                var section = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches ? '.mobile-section' : '.section';
                ShowFlat.$container.find(section).each(function(){
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            anime.timeline().add({
                                targets: $(this).find(".fade").toArray(),
                                // translateY: [40, 0],
                                opacity: [0, 1],
                                easing: 'easeOutCubic',
                                duration: 500,
                                // delay: function(el, j) {
                                //     return 200 * j;
                                // }
                                delay: 300
                            })
                            // .add({
                            //     targets: $(this).find("hr").toArray(),
                            //     width: [0, 100],
                            //     easing: 'easeOutCubic',
                            //     duration: 1000,
                            // }, 200)
                            .add({
                                targets: $(this).find('.image-col-mask')[0],
                                width: '100%',
                                easing: 'easeOutCubic',
                                duration: 900,
                            });
                            wp.destroy();
                        },
                        offset: '30%'
                    });
                });
                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            ShowFlat.$container.find('video').on("loadstart");
            ShowFlat.$container.find('.audio').on("click");
        },
        onLeaveCompleted: function() {
        
        }
    })
}

var Building = {
    $container: null,
    swiper: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'building',
        onEnter: function() {
            Building.$container = $(this.container);

            
            // Building.swiper = new Swiper (Building.$container.find('.swiper-container')[0], {
            //     slidesPerView: 1,
            //     observer: true,
            //     observeParents: true,
            //     effect: 'fade',
            //     fadeEffect: {
            //         crossFade: true
            //     },
            //     navigation: {
            //         nextEl: Building.$container.find('.swiper-button-next'),
            //         prevEl: Building.$container.find('.swiper-button-prev'),
            //     },
            //     on: {
            //         slideChangeTransitionStart: function(){
            //             var newIndex = Building.swiper.activeIndex;
            //             var oldIndex = Building.swiper.previousIndex;

            //             if($(Building.swiper.slides[oldIndex]).find('video').length){
            //                 $(Building.swiper.slides[oldIndex]).find('video')[0].pause();
            //                 Building.$container.find('.swiper-slide').eq(newIndex).find('button.play').show();
            //             }

            //             Building.$container.find('.control-wrapper button').eq(oldIndex).removeClass('active');
            //             Building.$container.find('.control-wrapper button').eq(newIndex).addClass('active');
            //             // if($(Building.swiper.slides[newIndex]).find('video').length) $(Building.swiper.slides[newIndex]).find('video')[0].play();
            //         }
            //     }
            // });
            
            // var bg = new Image();
            // bg.onload = function(){
            //     anime.timeline().add({
            //         targets: Building.$container.find('.background .image')[0],
            //         translateX: $(window).width() / 4,
            //         easing: 'easeOutCubic',
            //         duration: 2000
            //     }).add({
            //         targets: Building.$container.find('.content')[0],
            //         opacity: 1,
            //         easing: 'easeOutCubic',
            //         duration: 500
            //     }, 500).add({
            //         targets: Building.$container.find('.control-wrapper')[0],
            //         opacity: 1,
            //         easing: 'easeOutCubic',
            //         duration: 500
            //     }, 1500);
                
            // };
            // bg.src = "/site/templates/images/building_bkg.png";

            // Building.$container.find('video').each(function(){
            //     new Plyr(this, {
            //         hideControls: true,
            //         showPosterOnEnd: true,
            //         // fullscreen: {
            //         //     enabled: false
            //         // },
            //         controls: ['play-large', 'progress']
            //     });
            // });
            


            // events
            // Building.$container.find('video').on("loadstart play", function() {
            //     $(this).bgVideo({
            //         fullScreen: false
            //     });
            // });

            // Building.$container.find('button.play').on("click", function() {
            //     $(this).siblings('video')[0].play();
            //     $(this).hide();
            // });
            Building.$container.find('.control-wrapper button').hover(function(){
                var title = $(this).data('title');
                Building.$container.find('.background .title span').text(title);
                Building.$container.find('.background .title').show();
            }, function(){
                Building.$container.find('.background .title').hide();
            });

            Building.$container.find('.control-wrapper button').on("click", function() {
                var $this = $(this);
                var index = $(this).index();
                var title = $(this).data('title');
                var description = $(this).data('description');
                var src = $this.data('src');
                var scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
                // anime({
                //     targets: scrollElement,
                //     scrollTop: Building.$container.find('.section.video').offset().top,
                //     duration: 500,
                //     easing: 'easeOutQuad'
                // });

                fullpage_api.moveSectionDown();

                // Building.swiper.slideTo(index, 0);
                var $video = Building.$container.find('#video');
                var $title = Building.$container.find('.full-screen-video .title');
                var $description = Building.$container.find('.full-screen-video .description');
                // Building.$container.find('.section.video .figure').text(index + 1);
                // Building.$container.find('.section.video p').text(text);

                Building.$container.find('.control-wrapper button').not(this).removeClass('active');

                $title.text(title);
                $description.text(description);

                Building.$container.find('.control-wrapper button').eq(index).addClass('active');
                $video.find('source').attr('src', src);
                $video[0].load();
                $video[0].play();


                // Building.$container.find('.swiper-slide').eq(index).find('button.play').hide();
            });

            Building.$container.find('.controls-list button').on("click", function() {
                var index = $(this).closest('li').index();
                Building.$container.find('.control-wrapper button').eq(index).trigger('click');
            });

            $(window).on('resize orientationchange', function(){
                // Building.$container.find('.background').height($(window).height() * 2);
            });

            // Building.$container.find(".start360").on("click", function() {
            //     var $this = $(this);
            //     anime({
            //         targets: Building.$container.find(".start360")[0],
            //         opacity: 0,
            //         easing: 'easeOutCubic',
            //         duration: 500,
            //         complete: function(){
            //             $this.hide();
            //         }
            //     });

            //     anime({
            //         targets: Building.$container.find(".pano .overlay")[0],
            //         opacity: 0,
            //         easing: 'easeOutCubic',
            //         duration: 500,
            //         complete: function(){
            //             Building.$container.find(".pano .overlay").hide();
            //         }
            //     });

            //     anime({
            //         targets: Building.$container.find(".pano .text-col")[0],
            //         opacity: 0,
            //         easing: 'easeOutCubic',
            //         duration: 500,
            //         complete: function(){
            //             Building.$container.find(".pano .text-col").hide();
            //         }
            //     });
            // });

            
        },
        onEnterCompleted: function() {
            Common.initFullpage(Building.$container).then(function(){
                // Building.$container.find('.background').height($(window).height() * 2);
                
            });
            Common.pageTransitionEnter(Building.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                // window.scrollTo(0, 0);
                // Building.$container.find('.placeholder').each(function(){
                //     var wp = new Waypoint({
                //         element: this,
                //         handler: (d) => {
                //             anime.timeline().add({
                //                 targets: $(this).closest('.section').find(".fade").toArray(),
                //                 translateY: [40, 0],
                //                 opacity: [0, 1],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //                 delay: function(el, j) {
                //                     return 200 * j;
                //                 }
                //             }).add({
                //                 targets: $(this).closest('.section').find("hr").toArray(),
                //                 width: [0, 100],
                //                 easing: 'easeOutCubic',
                //                 duration: 1000,
                //             }, 200).add({
                //                 targets: Building.$container.find(".start360")[0],
                //                 opacity: [0, 100],
                //                 translateY: [40, 0],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //             }, 500);
                //             wp.destroy();
                //         },
                //         offset: '30%'
                //     });
                // });

                var section = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches.matches ? '.mobile-section' : '.section';
                Building.$container.find(section).each(function(){
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            anime.timeline().add({
                                targets: $(this).find(".fade").toArray(),
                                // translateY: [40, 0],
                                opacity: [0, 1],
                                easing: 'easeOutCubic',
                                duration: 500,
                                // delay: function(el, j) {
                                //     return 200 * j;
                                // }
                                delay: 300
                            })
                            // .add({
                            //     targets: $(this).find("hr").toArray(),
                            //     width: [0, 100],
                            //     easing: 'easeOutCubic',
                            //     duration: 1000,
                            // }, 200)
                            .add({
                                targets: $(this).find('.image-col-mask')[0],
                                width: '100%',
                                easing: 'easeOutCubic',
                                duration: 900,
                            });
                            wp.destroy();
                        },
                        offset: '30%'
                    });
                });

                // var wpControl = new Waypoint({
                //     element: Building.$container.find('.mobile-section.controls')[0],
                //     handler: (d) => {
                //         if(d === 'down'){
                //             Building.$container.find('.control-wrapper').css({
                //                 display: 'block'
                //             });
                //             anime({
                //                 targets: Building.$container.find('.control-wrapper').children().toArray(),
                //                 opacity: [0, 1],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //                 delay: function(el, j) {
                //                     return 50 * j;
                //                 }
                //             });
                //         }
                //     },
                //     offset: '50%'
                // });
                // var wpControl2 = new Waypoint({
                //     element: Building.$container.find('.mobile-section.controls')[0],
                //     handler: (d) => {
                //         if(d === 'up'){
                            
                //             anime({
                //                 targets: Building.$container.find('.control-wrapper').children().toArray(),
                //                 opacity: [1, 0],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //                 delay: function(el, j) {
                //                     return 50 * j;
                //                 },
                //                 complete: function(){
                //                     Building.$container.find('.control-wrapper').css({
                //                         display: 'none'
                //                     });
                //                 }
                //             });
                //         }
                //     },
                //     offset: '50%'
                // });
                // var wpControl3 = new Waypoint({
                //     element: Building.$container.find('.mobile-section.controls')[0],
                //     handler: (d) => {
                //         if(d === 'down'){
                            
                //             anime({
                //                 targets: Building.$container.find('.control-wrapper').children().toArray(),
                //                 opacity: [1, 0],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //                 delay: function(el, j) {
                //                     return 50 * j;
                //                 },
                //                 complete: function(){
                //                     Building.$container.find('.control-wrapper').css({
                //                         display: 'none'
                //                     });
                //                 }
                //             });
                //         }
                //     },
                //     offset: '-50%'
                // });
                // var wpControl4 = new Waypoint({
                //     element: Building.$container.find('.mobile-section.controls')[0],
                //     handler: (d) => {
                //         if(d === 'up'){
                //             Building.$container.find('.control-wrapper').css({
                //                 display: 'block'
                //             });
                //             anime({
                //                 targets: Building.$container.find('.control-wrapper').children().toArray(),
                //                 opacity: [0, 1],
                //                 easing: 'easeOutCubic',
                //                 duration: 500,
                //                 delay: function(el, j) {
                //                     return 50 * j;
                //                 }
                //             });
                //         }
                //     },
                //     offset: '-50%'
                // });

                var wpVideo = new Waypoint({
                    element: Building.$container.find('.section.full-screen-video')[0],
                    handler: (d) => {
                        if(d === 'down' && Building.$container.find('.section.full-screen-video video')[0]){
                            Building.$container.find('.section.full-screen-video video')[0].pause();
                        }
                    },
                    offset: '-200%'
                });

                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            Building.$container.find('video').off("loadstart");
            Building.$container.find('.control-wrapper button').off("click");
            Building.$container.find(".start360").off("click");
        },
        onLeaveCompleted: function() {
        }
    })
}

var Detail = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'detail',
        onEnter: function() {
            Detail.$container = $(this.container);

            
        },
        onEnterCompleted: function() {
            Detail.$container = $(this.container);
            Common.pageTransitionEnter(Detail.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                Detail.$container.find('.section').addClass("from-above");
            });

            // Detail.$container.find('img.ps-image').on('click', Common.imagesZoom)
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Location = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'location',
        map: null,
        mapScale: null,
        mapWidth: null,
        mapHeight: null,
        onEnter: function() {
            Location.$container = $(this.container);

            // Location.$container.find('.open-popup').on('click touch', function(e){
            //     var $content = $(e.currentTarget).find('.scrollable-popup-content');
            //     var popup = new ScrollablePopup();
            //     popup.open($content, 'panorama');
            //     fullpage_api.destroy();
            //     // fullpage_api.setAutoScrolling(false);
            //     $(document).scrollTop(0);

            //     popup.once('close', function(){
            //         Common.initFullpage(Location.$container, '', true);
            //     });
            // });

            
            
            if($('html').hasClass('ie')){
                $('iframe').attr('src', $('iframe').data('src'));
                $('iframe').css({
                    'display': 'inline'
                });
            }


            
             

             // var zoomed = false;
             // pan.on('zoom', function(e) {
             //    if(!zoomed){
             //        anime({
             //            targets: Location.$container.find('.zoom-indicator')[0],
             //            opacity: [0.5, 0],
             //            scale: [1, 2],
             //            duration: 500,
             //            easings: "easeOutCubic"
             //        });
             //        zoomed = true;
             //    }
                
             // });

       
            // new EasyPZ(Location.$container.find('.section.video .image>svg')[0], function(transform){}, { minScale: 1, maxScale: 2, bounds: { top: 0, right: 0, bottom: 0, left: 0 }}, ["PINCH_ZOOM", "PINCH_PAN","DBLCLICK_ZOOM_IN", "DBLCLICK_ZOOM_OUT"]);
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Location.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                var $panTarget = Location.$container.find('.panzoom');

                // var left = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches ? $(window).width() : $(window).width() - 250;
                var pan = panzoom($panTarget[0], {
                    // bounds: {
                    //     top: $(window).height(),
                    //     right: 200,
                    //     bottom: 200,
                    //     left: 2000
                    // },
                    minZoom: 1,
                    maxZoom: 5,
                    bounds: true,
                    boundsPadding: 1
                    // beforeWheel: function beforeWheel(e) {
                    //     var shouldIgnore = !e.altKey;
                    //     return shouldIgnore;
                    // }
                });

                if(window.matchMedia('(max-width: 767px)').matches){
                    var x = $panTarget.width() / 2;
                    var y = $panTarget.height() / 2;
                    pan.zoomTo(x,y,2);
                }else if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                    var x = $panTarget.width() / 2;
                    var y = $panTarget.height() / 2;
                    pan.zoomTo(x,y,1.5);
                }

                Location.$container.find('.zoom button').on('click touch', function(e){
                    e.preventDefault();
                    var $container = Location.$container.find('.background');
                    var rect = $container.offset();
                    var cx = $container.width()/2;
                    var cy = $container.height()/2;
                    var isZoomIn = e.target.id === 'zoomIn';
                    var zoomBy = isZoomIn ? 1.2 : 0.8;
                    pan.smoothZoom(cx, cy, zoomBy);
                });

                $(window).trigger('resize');
            });
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Contact = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'contact',
        onEnter: function() {
            Contact.$container = $(this.container);

            

            

            Contact.$container.find(".fade").css({
                opacity: 0
            });

            Contact.$container.find("form button[type='submit']").on('click', function(e){
                e.preventDefault();
                Parsley.options.errorsMessagesDisabled = true;
                var $form = Contact.$container.find('form');
                var p = $form.parsley();
                var formValid = p.validate();

                if(formValid){
                    $.ajax({
                        url: '/sendmail.php',
                        method: 'post',
                        data: $form.serialize(),
                        dataType: 'json',
                        beforeSend: function(){
                            $form.find('button').addClass('loading').attr('disabled','disabled');
                        },
                        success: function(response){
                            if(response['success']){
                                $form[0].reset();
                                $form.find('button').removeClass('loading').removeAttr('disabled');
                                Contact.$container.find('.success-message').show();
                            }else{
                                $form.find('button').removeClass('loading').removeAttr('disabled');
                                Contact.$container.find('.error-message').show();
                            }
                            
                        }
                    });
                }
            });
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Contact.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
                console.log('container ready');
                Contact.$container.find('.section').addClass("from-above");
                $(window).trigger('resize');
            });
        },
        onLeave: function() {
            Contact.$container.find('video').off("loadstart");
            Contact.$container.find('.audio').off("click");
            Contact.$container.find('button.play').off("click");
            Contact.$container.find('.section.video video').off('click');
        },
        onLeaveCompleted: function() {
        
        }
    })
}

var BrochureLanding = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'brochure',
        onEnter: function() {
            BrochureLanding.$container = $(this.container);
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(BrochureLanding.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                
            });
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Brochure = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'brochure-detail',
        onEnter: function() {
            Brochure.$container = $(this.container);

            Brochure.$container.find('a').each(function(){
                $(this).addClass('no-barba');
            });
        },
        onEnterCompleted: function() {
            Brochure.$container = $(this.container);
            Common.pageTransitionEnter(Brochure.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
                

                setTimeout(function(){
                    Common.loadScript("/site/templates/dflip/js/dflip.min.js").then(function(){
                        var pdf = Brochure.$container.find("#book").data('src');

                        var options = {
                          height: '100%', 
                          duration: 800,
                          webgl: true,
                          enableDownload: false,
                          scrollWheel: false,
                          pageMode: 2,
                          soundEnable: false,
                          backgroundColor: "transparent",
                          allControls: "altPrev,pageNumber,altNext,play,thumbnail,zoomIn,zoomOut,startPage,endPage",
                          moreControls: "",
                          beforeFlip: function (flipBook) {
                            $('.df-ui-btn').css({'pointer-events': 'none'});
                          },
                          onFlip: function (flipBook) {
                            $('.df-ui-btn').css({'pointer-events': 'auto'});
                          },
                        };


                        var flipBook = Brochure.$container.find("#book").flipBook(pdf, options);
                    });
                }, 400);
            });
        },
        onLeave: function() {
            TWEEN.removeAll();
        },
        onLeaveCompleted: function() {
        }
    })
}

var Gallery = {
    $container: null,
    removedEle: [],
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'gallery',
        onEnter: function() {
            Gallery.$container = $(this.container);

            // $(window).on('resize.gallery orientationchange.gallery', function(){
            //     if(!window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
            //         Gallery.$container.find('.section.mobile-show').each(function(i){
            //             Gallery.removedEle[i] = {};
            //             Gallery.removedEle[i]['prev'] = $(this).prev('.section.swiper-slide');
            //             Gallery.removedEle[i]['element'] = $(this);
            //             $(this).remove();
            //         });
            //     }else if(Gallery.removedEle){
            //         var temps = Gallery.removedEle;
            //         Gallery.removedEle = [];
            //         temps.forEach(function(data){
            //             data.element.insertAfter(data.prev);
            //         });
            //     }
            // }).trigger('resize');

            // Gallery.$container.find('.filter button').on('click', function(){
            //     var filter = $(this).data('filter');
            //     Gallery.$container.find('.filter button').removeClass('active');
            //     $(this).addClass('active');

            //     Gallery.$container.find('.gallery-list .image').each(function(){
            //         const $this = $(this);

            //         if(filter == 'all'){
            //             setTimeout(function(){
            //                 $this.removeClass('hidden');
            //                 setTimeout(function(){
            //                     $this.removeClass('hide');
            //                 }, 100);
            //             }, 300);
            //         }else if($this.data('type') !== filter){
            //             $this.addClass('hide');
            //             setTimeout(function(){
            //                 $this.addClass('hidden');
            //             }, 300);
            //         }else{
                        
            //             setTimeout(function(){
            //                 $this.removeClass('hidden');
            //                 setTimeout(function(){
            //                     $this.removeClass('hide');
            //                 }, 100);
            //             }, 300);
            //         }
            //     });
            // });
            Gallery.$container.find(".lazyload, .lazyloading").each(function(){
                lazySizes.loader.unveil(this);
            });
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(BrochureLanding.$container).then(function(){
                if(Common.$container.data('template') === 'home') return;
                Common.$container.find('.section-wrapper.swiper-container').each(function(i){
                    var $this = $(this);
                    var scrollbar = Common.isMobile() ? false : {
                            el: $this.find('.swiper-scrollbar'),
                            draggable: true,
                        };
                    // var index = $(this).closest(section).index(section);
                    var option = swiperMainOption($this, scrollbar);

                    if($('html').hasClass('ie')){
                        option.effect= 'fade';
                        option.fadeEffect = {
                            crossFade: true
                        };
                        option.on.slideChange = swiperIeEvent;
                        option.watchSlidesVisibility = false;
                        option.virtualTranslate = false;
                        option.watchSlidesProgress = false;
                        option.touchStartPreventDefault = true;
                    }

                    Common.sectionSlider = new Swiper (this, option);
                });
            });
            
        },
        onLeave: function() {
            // $(window).off('resize.gallery orientationchange.gallery');
        },
        onLeaveCompleted: function() {
        }
    })
}

var Plans = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'plans',
        onEnter: function() {
            Plans.$container = $(this.container);

            Plans.$container.find('.switch button').on('click', function(){
                var target = $(this).data('target');
                Plans.$container.find('.switch button').removeClass('active');
                $(this).removeClass('active');
                $(this).siblings().addClass('active');

                Plans.$container.find('.tab').each(function(){
                    if($(this).data('tab') !== target){
                        $(this).hide();
                    }else{
                        $(this).css({
                            display: 'flex'
                        });
                    }
                });
            });
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Plans.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Dummy = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'dummy',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Dummy.$container = $(this.container);
            Common.pageTransitionEnter(Dummy.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var P404 = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'http404',
        onEnter: function() {
            Common.pageTransitionEnter();
        },
        onEnterCompleted: function() {
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

class ScrollablePopup {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-popup'><div class='overlay close'></div><div class='content'></div></div>";
        this.$popup = null;
        this.eventQueue = {};
        Common.popupInstances.push(this);
    }

    open($element, popupClass){
        var _this = this;
        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$contener = Common.popupInstances.length > 1 ? Common.popupInstances[Common.popupInstances.length - 2].$popup : $element.closest('.transition-container');
        if(Common.sidebarInstances.length > 0) _this.$contener = Common.sidebarInstances[Common.sidebarInstances.length - 1].$sidebar;
        _this.top = $(document).scrollTop();
        _this.$contener.css({
            position: "fixed",
            top: -_this.top,
            overflow: "hidden"
        });
        // $(".sticky").css({
        //  position: "fixed",
        //  top: 0
        // });
        _this.$popup = $(_this.markup).clone();
        _this.$popup.addClass(popupClass);
        _this.$popup.find('.content').append($element);

        $("body").append(_this.$popup);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$popup[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$popup.find('.content')[0],
            opacity: [0,1],
            translateY: [40, 0],
            duration: 500
        });

        _this.$popup.find('.close').on('click touch',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-popup").length){
            var _this = this;
            var top = goTop ? 0 : this.top;
            anime({
                targets: this.$popup[0],
                opacity: 0,
                easing: 'easeOutCubic',
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$popup.remove();
                    _this.$contener.css({
                        position: "relative",
                        top: "auto",
                        overflow: ""
                    });
                    // $(".sticky").css({
                    //  position: "sticky",
                    //  top: "auto"
                    // });
                    $(document).scrollTop(top);
                    _this.destroy();

                    if(!$('html').hasClass('ie')) _this.trigger('close');

                    if(_this.eventQueue['close']) _this.eventQueue['close'] = [];
                }
            });
        }
    }

    once(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if(this.eventQueue[event]) {
            for(var i in this.eventQueue[event])
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.popupInstances.indexOf(this);
        Common.popupInstances.splice(i, 1);
        delete this;
    }
}


class ScrollableSidebar {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-sidebar'><div class='overlay close'></div><div class='content'></div></div>";
        this.$sidebar = null;
        this.position = null;
        this.eventQueue = {};
        Common.sidebarInstances.push(this);
    }

    open($element, sidebarClass, position){
        var _this = this;
        _this.position = position;
        var animationDirection = position === 'right' ? 320 : -320;
        var positionClass = position === 'right' ? 'right' : 'left';

        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$contener = Common.sidebarInstances.length > 1 ? Common.sidebarInstances[Common.sidebarInstances.length - 2].$sidebar : $element.closest('.transition-container');
        _this.top = $(document).scrollTop();
        _this.$contener.css({
            position: "fixed",
            top: -_this.top,
            overflow: "hidden"
        });
        _this.$sidebar = $(_this.markup).clone();
        _this.$sidebar.addClass(sidebarClass).addClass(positionClass);
        _this.$sidebar.find('.content').append($element);

        $("body").append(_this.$sidebar);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$sidebar[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$sidebar.find('.content')[0],
            translateX: [animationDirection, 0],
            duration: 500
        });

        _this.$sidebar.find('.close').on('click',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-sidebar").length){
            var _this = this;
            var animationDirection = _this.position === 'right' ? 320 : -320;
            var top = goTop ? 0 : _this.top;
            anime.remove(_this.$sidebar[0]);
            anime.remove(_this.$sidebar.find('.content')[0]);

            anime.timeline({
                easing: 'easeOutCubic'
            }).add({
                targets: this.$sidebar.find('.content')[0],
                translateX: animationDirection,
                duration: 200,
            }).add({
                targets: this.$sidebar[0],
                opacity: 0,
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$sidebar.remove();
                    _this.$contener.css({
                        position: "relative",
                        top: "auto",
                        overflow: ""
                    });

                    $(document).scrollTop(top);
                    _this.destroy();
                    _this.trigger('close');
                }
            }, 0);
        }
    }

    on(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if( this.eventQueue[event] ) {
            for( i in this.eventQueue[event] )
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.sidebarInstances.indexOf(this);
        Common.sidebarInstances.splice(i, 1);
        delete this;
    }
}

var SwiperCustom = {
    progress(swiper, progress) {

    },
    setTransition(swiper, transitionSpeed) {
        
    },
    setTranslate(swiper, wrapperTranslate) {
        // const durationInSeconds = this.getTransitionSpeed() / 1000;
        const slides = Object.values(swiper.slides).slice(0, -1);
        // const originIndex = Creation.getActiveIndexBeforeTransitionStart(
        //   swiper,
        //   slides
        // );
        const originIndex = swiper.activeIndex;
        var newIndex = 0;
        const isDragging = !Math.abs(slides[swiper.activeIndex].progress%1 === 0);
        if(isDragging){
            newIndex = originIndex;
        }else{
            const step = slides[swiper.activeIndex].progress;
            newIndex = originIndex + step;
        }
        if($(slides[newIndex]).hasClass('dark')){
            $('html').addClass('dark-section');
        }else{
            $('html').removeClass('dark-section');
        }

        if($(slides[newIndex]).hasClass('mobile-light')){
            $('html').addClass('mobile-light-section');
        }else{
            $('html').removeClass('mobile-light-section');
        }

        if(originIndex !== newIndex){
            $(slides).each(function(){
                $(this).removeClass('from-below to-below from-above to-above');
            });

            if($(slides[newIndex]).find('.text-col').length){
                $(slides[newIndex]).find('.text-col')[0].scrollTop = 0;
            }

            if(originIndex > newIndex){
                $(slides[newIndex]).addClass('from-below');
                $(slides[originIndex]).addClass('to-above');
            }else{
                $(slides[newIndex]).addClass('from-above');
                $(slides[originIndex]).addClass('to-below');
            }

            // play and stop video
            if($(slides[newIndex]).find('.video-bkg video').length){
                var video = $(slides[newIndex]).find('.video-bkg video')[0];
                video.currentTime = 0;
                video.play();
            }
            if($(slides[originIndex]).find('.video-bkg video').length){
                $(slides[originIndex]).find('.video-bkg video')[0].pause();
            }

            setTimeout(function(){
                swiper.animating = false;
            }, 600);

            $(slides[newIndex]).find('.lazyload').each(function(){
                $(this).show();
            });
            
        }

        

        // console.log(originIndex);
        // var newIndex = 0;
        // if(swiper.swipeDirection === 'next') newIndex = originIndex + 1;
        // else if(swiper.swipeDirection === 'prev') newIndex = originIndex - 1;

        // const animationProgress = slides[originIndex].progress;console.log(animationProgress);
        // const newIndex = originIndex + Creation.getDirection(animationProgress);
        // console.log(newIndex,originIndex);
// console.log(originIndex);
        slides.map((slide, index) => {
            if(originIndex < 0) return;
            if(originIndex > newIndex){
                if($(slides[newIndex]).data('animation-next') === 'fade'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "pointer-events": "all",
                            "z-index": slides.length + 2
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "opacity": 0,
                            "pointer-events": "all",
                            "z-index": slides.length - index
                        });
                    }
                }else if($(slides[newIndex]).data('animation-next') === 'mask'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "-webkit-clip-path": "inset(0 0 0 0)",
                            "clip-path": "inset(0px 0px 0px 0px)",
                            "pointer-events": "all",
                            "z-index": slides.length + 2
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "-webkit-clip-path": "inset(0 0 100% 0)",
                            "clip-path": "inset(0 0 100% 0)",
                            "pointer-events": "none",
                            "z-index": slides.length - index
                        });
                    }
                }
            }else{
                if($(slides[newIndex]).data('animation-prev') === 'fade'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "pointer-events": "all",
                            "z-index": slides.length + 1
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "opacity": 0,
                            "pointer-events": "all",
                            "z-index": slides.length - index
                        });
                    }
                }else if($(slides[newIndex]).data('animation-prev') === 'mask'){
                    if(index === newIndex){
                        $(slide).css({
                            "display": "flex",
                            "display": "-ms-flexbox",
                            "opacity": 1,
                            "-webkit-clip-path": "inset(0 0 0 0)",
                            "clip-path": "inset(0px 0px 0px 0px)",
                            "pointer-events": "all",
                            "z-index": slides.length + 1
                        });
                    }else if(index < newIndex){
                        if($(slide).data('animation-next') === 'fade'){
                            $(slide).css({
                                "opacity": 0,
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }else if($(slide).data('animation-next') === 'mask'){
                            $(slide).css({
                                "-webkit-clip-path": "inset(0 0 100% 0)",
                                "clip-path": "inset(0 0 100% 0)",
                                "pointer-events": "none",
                                "z-index": slides.length - index
                            });
                        }
                    }else{
                        $(slide).css({
                            "-webkit-clip-path": "inset(0 0 100% 0)",
                            "clip-path": "inset(0 0 100% 0)",
                            "pointer-events": "none",
                            "z-index": slides.length - index
                        });
                    }
                }
            }

          // const offset = slide.swiperSlideOffset;
          // let x = -offset;
          // if (!swiper.params.virtualTranslate) x -= swiper.translate;
          // let y = 0;
          // if (!swiper.isHorizontal()) {
          //   y = x;
          //   x = 0;
          // }
          // TweenMax.set(slide, {
          //   x,
          //   y
          // });

          // const clip = (val, min, max) => Math.max(min, Math.min(val, max));
          // const ZOOM_FACTOR = 0.05;

          // const opacity = Math.max(1 - Math.abs(slide.progress), 0);

          // const clippedProgress = clip(slide.progress, -1, 1);
          // const scale = 1 - ZOOM_FACTOR * clippedProgress;

          // TweenMax.to(slide, durationInSeconds, {
          //   scale,
          //   opacity
          // });
        });
    },
    getActiveIndexBeforeTransitionStart(swiper, slides) {
        const isDragging = !Math.abs(slides[swiper.activeIndex].progress === 1);
        if (isDragging) {
            return swiper.slidesGrid.indexOf(
                -swiper.touchEventsData.startTranslate || swiper.params.initialSlide
            );
        } else {
            return swiper.activeIndex;
        }
    },
    getDirection(animationProgress) {
        if (animationProgress === 0) {
            return 0;
        } else if (animationProgress > 0) {
            return 1;
        } else  if (animationProgress < 0){
            return -1;
        }else{
            return 0;
        }
    }
}

var swiperMainOption = function($this, scrollbar){
    return {
        effect: 'mask',
        speed: 1000,
        watchSlidesVisibility: true,
        virtualTranslate: true,
        watchSlidesProgress: true,
        touchStartPreventDefault: false,
        // longSwipesRatio: 0,
        // simulateTouch: false,
        mousewheel: {
            // invert: true,
        },
        direction: 'vertical',
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false
        // },
        // navigation: {
        //     nextEl: $(this).siblings('.slider>.swiper-button-next'),
        //     prevEl: $(this).siblings('.slider>.swiper-button-prev'),
        // },
        scrollbar: scrollbar,
        pagination: {
              el: $this.find('.swiper-pagination.nav')[0],
              clickable: true
        },
        on: {
            init: function(){
                var swiper = this;
                var slides = $(swiper.slides);
                slides = slides.filter(function() {
                    return $(this).is(":visible");
                });

                for (var i = 0; i < slides.length; i += 1) {
                  var $slideEl = slides.eq(i);
                  var offset = swiper.height * i;
                  var tx = -offset;
                  if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
                  var ty = 0;
                  if (!swiper.isHorizontal()) {
                    ty = tx;
                    tx = 0;
                  }
                  var slideOpacity = swiper.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
                    : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
                  $slideEl.css({
                    "z-index": slides.length - i,
                  });

                  // $slideEl.height(offset);
                  $slideEl.css({
                    transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
                  });

                  if(i === 0){
                    $slideEl.addClass("from-above");

                    if($slideEl.hasClass('dark')){
                        $('html').addClass('dark-section');
                    }else{
                        $('html').removeClass('dark-section');
                    }

                    if($slideEl.hasClass('mobile-light')){
                        $('html').addClass('mobile-light-section');
                    }else{
                        $('html').removeClass('mobile-light-section');
                    }

                    if($slideEl.find('.video-bkg video').length) $slideEl.find('.video-bkg video')[0].play();
                  }

                  // $slideEl.css({
                  //   transition: "all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s"
                  // });
                }

                setTimeout(function(){
                    Common.$container.find('.section.swiper-slide').css({
                        transition: "all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s"
                    });
                }, 600);

                setTimeout(function(){
                    swiper.update();
                    for (var i = 0; i < slides.length; i += 1) {
                      var $slideEl = slides.eq(i);
                      var offset = swiper.height * i;
                      var tx = -offset;
                      if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
                      var ty = 0;
                      if (!swiper.isHorizontal()) {
                        ty = tx;
                        tx = 0;
                      }
                      $slideEl.css({
                        transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
                      });
                    }
                }, 100);

                Common.$container.find('.section-anchor').on('click', function(){
                    var target = $(this).data('target');
                    swiper.slideTo(target, 0, false);
                });

                enableTouchSwipe();
                // $(window).on('mousewheel', function(e){
                //     console.log(e);
                // });
            },
            resize: function(){
                var swiper = this;
                var slides = $(swiper.slides);
                slides = slides.filter(function() {
                    return $(this).is(":visible");
                });
                for (var i = 0; i < slides.length; i += 1) {
                  var $slideEl = slides.eq(i);
                  var offset = swiper.height * i;
                  var tx = -offset;
                  if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
                  var ty = 0;
                  if (!swiper.isHorizontal()) {
                    ty = tx;
                    tx = 0;
                  }
                  var slideOpacity = swiper.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
                    : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
                    swiper.update();
                    $slideEl.css({
                        transform: "translate3d(" + tx + "px, " + ty + "px, 0px)"
                    });
                    
                  
                }
                
                // swiper.updateSlidesOffset();
                // swiper.update();
                // window.location.reload(false); 
                
            },
            progress(progress) {
                const swiper = this;
                if (swiper.params.effect !== "mask") return;
                SwiperCustom.progress(swiper, progress);
            },
            setTransition(speed) {
                const swiper = this;
                if (swiper.params.effect !== "mask") return;
                SwiperCustom.setTransition(swiper, speed);
            },
            setTranslate(translate) {
                const swiper = this;
                if (swiper.params.effect !== "mask") return;
                SwiperCustom.setTranslate(swiper, translate);
            },
            // touchStart(e){
            //     if($(e.target).closest('.scrollable').length){
            //         e.preventDefault();
            //     }else{

            //     }
            // },
            // touchEnd(){
                
            // },
        }
    }
};

var swiperIeEvent = function(){
    const swiper = this;
    const slides = swiper.slides;
    Common.newIndex = swiper.activeIndex;

    if($(slides[Common.newIndex]).hasClass('dark')){
        $('html').addClass('dark-section');
    }else{
        $('html').removeClass('dark-section');
    }

    if(Common.originIndex > Common.newIndex){
        $(slides[Common.newIndex]).addClass('from-below');
        $(slides[Common.originIndex]).addClass('to-above');
    }else{
        $(slides[Common.newIndex]).addClass('from-above');
        $(slides[Common.originIndex]).addClass('to-below');
    }

    // play and stop video
    if($(slides[Common.newIndex]).find('.video-bkg video').length){
        var video = $(slides[Common.newIndex]).find('.video-bkg video')[0];
        video.currentTime = 0;
        video.play();
    }
    if($(slides[Common.originIndex]).find('.video-bkg video').length){
        $(slides[Common.originIndex]).find('.video-bkg video')[0].pause();
    }

    $(slides).each(function(index, slide){
        if(Common.originIndex < 0) return;
        if(index === Common.newIndex){
            $(slide).css({
                "z-index": $(slides).length + 1
            });
        }else{
            $(slide).css({
                "z-index": $(slides).length - index
            });
        }
    });

    Common.originIndex = Common.newIndex;
}

var enableTouchSwipe = function(){
    Common.touchStart = 0;
    Common.touchEnd = 0;
    Common.scrollPos = 0;
    Common.startPos = '';
    Common.sliding = false;
    Common.startTime = 0;
    Common.endTime = 0;

    $('body')[0].addEventListener("touchstart",function(e){
        var index = Common.sectionSlider.activeIndex;
        var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');
        Common.touchStart = e.touches[0].clientY;
        Common.scrollPos = $activeSection.scrollTop();
        const isBottom = $activeSection.length && $activeSection[0].scrollHeight - $activeSection[0].scrollTop === $activeSection[0].clientHeight;
        const isBelowBottom = $activeSection.length && $activeSection[0].scrollHeight - $activeSection[0].scrollTop < $activeSection[0].clientHeight;
        const isTop = $activeSection.length && $activeSection[0].scrollTop === 0;
        const isAboveTop = $activeSection.length && $activeSection[0].scrollTop < 0;

        if (isBottom && isTop) {
            Common.startPos = 'all';
        }else if (isBottom) {
            Common.startPos = 'bottom';
        }else if (isTop) {
            Common.startPos = 'up';
        }else if (isBelowBottom) {
            Common.startPos = 'below';
        }else if (isAboveTop) {
            Common.startPos = 'above';
        }else{
            Common.startPos = '';
        }

        Common.touchStart = e.touches[0].clientY;
        Common.scrollPos = $activeSection.scrollTop();
        Common.startTime = + new Date();
    }, {passive: false });

    $('body')[0].addEventListener("touchmove",function(e){
        // e.preventDefault();
        Common.touchEnd = e.touches[0].clientY;
        var index = Common.sectionSlider.activeIndex;
        var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');

        // next section if touchstart at bottom and move distance more than 30px

        if ((Common.startPos === 'all' || Common.startPos === 'bottom') && !Common.sliding && Common.touchEnd - Common.touchStart <= -20) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slideNext();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if ((Common.startPos === 'all' || Common.startPos === 'up') && !Common.sliding && Common.touchEnd - Common.touchStart >= 20) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slidePrev();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }if ( Common.startPos === 'below' && !Common.sliding && Common.touchEnd - Common.touchStart <= -100) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slideNext();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if (Common.startPos === 'above' && !Common.sliding && Common.touchEnd - Common.touchStart >= 100) {
            Common.startPos = '';
            Common.sliding = true;
            Common.sectionSlider.slidePrev();

            setTimeout(function(){
                Common.sliding = false;
            }, 300);
        }else if(!Common.sliding){
            // $activeSection[0].scrollTop = Common.scrollPos - Common.touchEnd + Common.touchStart;
            Common.endTime = + new Date();
        }
    }, {passive: false });

    $('body')[0].addEventListener("touchend",function(e){
        if(!Common.sliding){
            var index = Common.sectionSlider.activeIndex;
            var $activeSection = Common.$container.find('.section').eq(index).find('.text-col');
            if($activeSection.length) Common.scrollPos = $activeSection[0].scrollTop;
            // var time = Common.endTime - Common.startTime;
            // anime({
            //     targets: $activeSection[0],
            //     scrollTop: Common.scrollPos + 1/(time / 100)* (- Common.touchEnd + Common.touchStart),
            //     duration: 300,
            //     easing: 'easeOutQuad'
            // });
        }
    }, {passive: false });
}

var Polyfill = {
    init: function(){
        if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            };
        }
    }
}

$(function(){
    Polyfill.init();

    Home.init();
    Vision.init();
    Collaboration.init();
    Creation.init();
    ShowFlat.init();
    Building.init();
    Location.init();
    Detail.init();
    Contact.init();
    BrochureLanding.init();
    Brochure.init();
    Gallery.init();
    Plans.init();
    Dummy.init();
    Common.init();
    P404.init();
    Barba.Pjax.init();
});


